import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar, Footer } from './modules';
import { MainPage, PortfolioPage, PortfolioCategoryPage, PricesPage } from './pages';

function App() {
  return (
    <BrowserRouter>
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route
              path="/portfolio"
              element={
                <div className="mx-auto w-full max-w-7xl px-3 py-6 md:px-10 md:py-12">
                  <PortfolioPage />
                </div>
              }
            />
            <Route
              path="/portfolio/:slug"
              element={
                <div className="mx-auto w-full max-w-7xl px-5 py-8 md:px-10 md:py-12">
                  <PortfolioCategoryPage />
                </div>
              }
            />
            <Route
              path="/prices"
              element={
                <div className="mx-auto w-full max-w-7xl px-5 py-8 md:px-10 md:py-12">
                  <PricesPage />
                </div>
              }
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
